module.exports = __webpack_public_path__ + "img/prev-arrow-grey.3733ab6c.svg";